import HmsEntityTableController from 'components/HmsEntityTableController';
import useEntities from 'hooks/useEntities';
import useLoginStore from 'store/loginStore';

const Organizations = () => {
  const entities = useEntities();
  const filterGroups = null;
  const showColumns = ['NameWithLogo', 'nick', 'short', 'status'];
  const isSystemAdmin = useLoginStore(s => s.isSystemAdmin)();

  return (
    <HmsEntityTableController
      entity={entities.Organization}
      filterGroups={filterGroups}
      showColumns={showColumns}
      canCreate = {isSystemAdmin}
    />
  )
}

export default Organizations